var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center cam-player-switch"},[(_vm.vCam.serviceType === 'HLS')?_c('CamVideoJs',{ref:"playerJs",attrs:{"cam":_vm.vCam,"isHd":_vm.isHd,"isLive":_vm.isLive,"start":_vm.start,"end":_vm.end}}):_c('CamPlayerEz',{ref:"playerEz",attrs:{"cam":_vm.vCam,"isHd":_vm.isHd,"isLive":_vm.isLive,"start":_vm.start,"end":_vm.end}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }